module.exports = __webpack_public_path__ + "img/myCheck.ce4b81ad.png";